import * as React from "react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Link } from "@/components/common/Link";
const galleryImages = [{
  src: "https://oldwatermusic.com/wp-content/uploads/2026/07/Screenshot-2024-02-12-at-16.33.26.png?v=4cwv8mxx7f8",
  srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Final-Album-Cover-AAOM-scaled.png?v=7y67ujqne5",
  sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Final-Album-Cover-AAOM-scaled.png?v=g0hzyh2bzc6",
  alt: "IWAH",
  caption: "INTERVIEW WITH A HITMAN",
  credits: "'Melody Stay' by Øld Water used as theme song",
  link: "https://www.imdb.com/title/tt23836970/?ref_=nv_sr_srsg_5_tt_7_nm_1_in_0_q_interview%20with%20a%20hit"
}, {
  src: "https://oldwatermusic.com/wp-content/uploads/2026/07/IMG-20220718-WA0000.jpg?v=fguqhdfanou",
  srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/FINAL-Portada-scaled.png?v=ppgfkshqkk-wvc-srcset",
  sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/FINAL-Portada-scaled.png?v=7nr9bjeibo-wvc-sizes",
  alt: "WM",
  caption: "WICKLOW MONSTERS",
  credits: "'Pickin' On Me' by Øld Water used as opening theme",
  link: "https://www.imdb.com/title/tt23860974/"
}, {
  src: "https://oldwatermusic.com/wp-content/uploads/2026/07/Screenshot-2024-02-12-at-16.37.07.png?v=1c35gu3k5ks",
  srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Cover-FINAL-scaled.png?v=kx7z3en4ses-wvc-srcset",
  sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Cover-FINAL-scaled.png?v=4zb26fxnct2-wvc-sizes",
  alt: "JC",
  caption: "JUST CHARLIE",
  credits: "'Strong' by Ruth Owens featuring Johannes' Guitar playing and arranging",
  link: "https://www.imdb.com/title/tt4838248/?ref_=nv_sr_srsg_0_tt_5_nm_3_in_0_q_just%20charlie"
}];
export default function StaticAlbumGallery() {
  return <section data-section-id="256222" id="static-album-gallery" className="text-foreground py-8 md:py-12 border-t border-border bg-background/40">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl">
        <h2 className="font-bold font-serif uppercase tracking-tighter mb-4 !text-3xl">APPEARANCES IN TV & FILM</h2>
        <p className="font-mono text-sm md:text-base text-muted-foreground mb-8 md:mb-12 max-w-3xl uppercase tracking-wider"><span className="!font-sans" data-ast-id="f:/src/pages/Portfolio/sections/StaticAlbumGalleryCopy.tsx|sig:yzi4fj" data-ast-start="13914" data-ast-end="14151"><span className="!font-serif" data-ast-id="f:/src/pages/Portfolio/sections/StaticAlbumGalleryCopy.tsx|sig:2tk5ed" data-ast-start="13943" data-ast-end="14144" contenteditable="false" style={{}}>SONG APPEARANCES IN FILM & TV. HOVER THE MOUSE OVER EACH IMAGE FOR SPECIFIC SONG INFO OR TO FIND OUT MORE</span></span></p>
        
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-5">
          {galleryImages.map((image, i) => <Link key={i} to={image.link} newTab data-index={i} className="group relative overflow-hidden rounded-md shadow-md bg-card">
              <AspectRatio ratio={1 / 1}>
                <img src={image.src} data-wvc-srcset={image.srcset} data-wvc-sizes={image.sizes} alt={image.alt} loading="lazy" className="object-cover w-full h-full transition-transform duration-700 ease-out group-hover:scale-110" />
                <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col items-center justify-center p-4">
                  <span className="text-primary font-default text-sm md:text-base font-semibold text-center tracking-tight uppercase">
                    {image.caption}
                  </span>
                  {image.credits && <p className="text-primary/80 font-default text-xs text-center mt-1">
                      {image.credits}
                    </p>}
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-secondary/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none mix-blend-overlay" />
              </AspectRatio>
            </Link>)}
        </div>
      </div>
    </section>;
}